import { Frecuencia } from 'modelos/src';

/**
 * Qué frecuencias de `IConfigEventoUsuario` respeta el backend que evalúa
 * cada condición de activo / vehículo. Lo usan el wizard de reglas de
 * vehículo y el formulario de Eventos personalizados, para ofrecer lo mismo.
 *
 * - api-eventos (velocidad, exceso por calle, ubicación, recorridos):
 *   vigencia (validaDesde/validaHasta), "sólo una vez" (desactiva la regla)
 *   y cronograma.
 * - trackers-go (detenido): vigencia y cronograma; no desactiva la regla.
 * - Divergencia GPS: no consulta ninguna, siempre es continua.
 *
 * "Generar si no se cumple" no aplica a activos ni vehículos: sólo lo
 * implementan las alarmas "no llega evento".
 */
export type CondicionActivo =
  | 'Velocidad'
  | 'Exceso de velocidad por calle'
  | 'Ubicación'
  | 'Detenido'
  | 'Recorridos'
  | 'Divergencia GPS';

const TODAS: Frecuencia[] = [
  'Continua',
  'Unica',
  'Continua en un periodo',
  'Unica en un periodo',
  'Cronograma',
];

export const FRECUENCIAS_POR_CONDICION: Record<CondicionActivo, Frecuencia[]> =
  {
    Velocidad: TODAS,
    'Exceso de velocidad por calle': TODAS,
    Ubicación: TODAS,
    Recorridos: TODAS,
    Detenido: ['Continua', 'Continua en un periodo', 'Cronograma'],
    'Divergencia GPS': ['Continua'],
  };

/** Frecuencias admitidas para una condición de activo. Sin condición (o una
 *  que no es de activo) no se restringe. */
export function frecuenciasAdmitidas(condicion?: string | null): Frecuencia[] {
  return FRECUENCIAS_POR_CONDICION[condicion as CondicionActivo] ?? TODAS;
}
